import logo from "@/assets/postflow-logo.png";
import { Link } from "react-router-dom";

const EMAIL = "contato@ctr2sr.com.br";
const UPDATED = "Junho de 2026";

export default function ExclusaoDados() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800" data-testid="data-deletion-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-6 py-4">
          <img src={logo} alt="PostFlow AI" className="h-9 w-9 rounded-lg" />
          <div>
            <div className="font-display text-lg font-extrabold text-slate-900">PostFlow AI</div>
            <div className="text-xs text-slate-500">Exclusão de Dados do Usuário</div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">
          Instruções para Exclusão de Dados
        </h1>
        <p className="mt-2 text-sm text-slate-500">Última atualização: {UPDATED}</p>

        <section className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed [&_h2]:mt-8 [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:mt-3 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:mt-1">
          <p>
            Na PostFlow AI você tem o direito de solicitar a exclusão de todos os seus dados pessoais e das conexões
            com redes sociais (incluindo tokens de acesso do Instagram/Facebook obtidos via Meta) a qualquer momento.
          </p>

          <h2>Como solicitar a exclusão</h2>
          <p>Você pode escolher uma das opções abaixo:</p>
          <ol>
            <li>
              <strong>Dentro do aplicativo:</strong> acesse <em>Central de Conexões</em> e desconecte suas contas de
              redes sociais; em seguida, na área da sua organização, exclua as marcas e o conteúdo desejados. Para
              excluir a conta por completo, use a opção abaixo por e-mail.
            </li>
            <li>
              <strong>Por e-mail:</strong> envie uma mensagem para{" "}
              <a href={`mailto:${EMAIL}`} className="text-[#3457d5] font-semibold">{EMAIL}</a> com o assunto
              <strong> "Exclusão de dados"</strong>, informando o e-mail cadastrado na sua conta.
            </li>
          </ol>

          <h2>O que será excluído</h2>
          <ul>
            <li>Dados de conta (nome, e-mail e credenciais).</li>
            <li>Marcas, campanhas, conteúdos e mídias associadas.</li>
            <li>Tokens e informações das integrações com Instagram/Facebook (Meta) e demais redes.</li>
          </ul>

          <h2>Prazo</h2>
          <p>
            Processamos as solicitações de exclusão em até <strong>30 dias</strong>. Após a conclusão, seus dados
            pessoais e tokens de integração são removidos permanentemente dos nossos sistemas, salvo quando a
            retenção for exigida por obrigação legal.
          </p>

          <h2>Revogar acesso pela Meta</h2>
          <p>
            Você também pode remover o acesso da PostFlow AI diretamente na Meta: acesse as configurações da sua conta
            do Facebook em <em>Configurações e privacidade → Configurações → Aplicativos e sites</em> e remova a
            PostFlow AI. Isso revoga imediatamente os tokens usados para publicação.
          </p>

          <h2>Contato</h2>
          <p>
            Precisa de ajuda com a exclusão dos seus dados? Fale conosco pelo e-mail{" "}
            <a href={`mailto:${EMAIL}`} className="text-[#3457d5] font-semibold">{EMAIL}</a>.
          </p>
        </section>

        <div className="mt-10 border-t border-slate-200 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm">
          <Link to="/" className="text-[#3457d5] font-semibold" data-testid="data-deletion-home-link">← Voltar ao início</Link>
          <nav className="flex flex-wrap gap-x-4 gap-y-1 text-slate-500">
            <Link to="/termos" className="hover:text-[#3457d5]">Termos</Link>
            <Link to="/privacidade" className="hover:text-[#3457d5]">Privacidade</Link>
            <Link to="/exclusao-de-dados" className="hover:text-[#3457d5]">Exclusão de Dados</Link>
          </nav>
        </div>
      </main>
    </div>
  );
}
